import React from "react";
import "../Styles/CategoryCard.css";
import { Link } from "react-router-dom";

const CategoryCard = ({ heading, content, btnText, btnIcon, link, image }) => {
  return (
    <div className="category-card">
      <div className="category-card-img">
        <img src={image} />
      </div>
      <div className="category-card-content">
        <h3>{heading}</h3>
        <ul>
          {content.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        <Link to={link} className="link">
          <button>
            {btnText} <img src={btnIcon} />
          </button>
        </Link>
      </div>
    </div>
  );
};

export default CategoryCard;
